import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import jwt_decode from "jwt-decode";
// import Cookies from 'universal-cookie';
import { useEffect, useState } from "react";
import Loader from '../Animations/Loader';
import { getCcDecrypt } from "../../ApiCalls/LoginAuthenticateApi/api_v1_login_validate";
const useAuth = () => {
    // const cookies = new Cookies();
    // let isTokenAvailable = sessionStorage.getItem("token");
    let location = useLocation();
    const [loggedIn, setLoggedIn] = useState(null);
    // useEffect(() => {
    //     if (isTokenAvailable) {
    //         const decoded = jwt_decode(isTokenAvailable);
    //         const auth = decoded.userInfo['auth'];
    //         if (auth === 1) {
    //             setLoggedIn(true);
    //         }
    //     }
    //     else {
    //         setLoggedIn(false);
    //     }

    // }, [location.pathname])
    const token = sessionStorage.getItem("token"); // assuming your token is stored here

    useEffect(() => {
        const checkTokenValidity = async () => {
            if (token) {
                try {
                    // Optional: decrypt msisdn if needed
                    // const authenticateUser = await getDecryptMsisdn({ encMsisdn: u });

                    // Validate token with Laravel
                    const res = await getCcDecrypt();

                    if (res.status === 200 && res.data.message === "success") {
                        const decoded = jwt_decode(token);
                        const auth = decoded.userInfo?.auth;
                        if (auth === 1) {
                            setLoggedIn(true);
                            return;
                        }
                    }

                    setLoggedIn(false);
                } catch (error) {
                    setLoggedIn(false);
                }
            } else {
                setLoggedIn(false);
            }
        };

        checkTokenValidity();
    }, [location.pathname]);
    return loggedIn
}


const ProtectedRoutes = () => {
    const isAuth = useAuth();
    if (isAuth === null) // waiting..
    { return <Loader />; }

    return isAuth ? <Outlet /> : <Navigate to="/login" />
}


export default React.memo(ProtectedRoutes);